import { render } from "./HeaderContent.vue?vue&type=template&id=3785c98c&scoped=true"
import script from "./HeaderContent.vue?vue&type=script&lang=js"
export * from "./HeaderContent.vue?vue&type=script&lang=js"

import "./HeaderContent.vue?vue&type=style&index=0&id=3785c98c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3785c98c"]])

export default __exports__